import { useEffect, useLayoutEffect, useState } from 'react'

import { GtmAgent } from 'utils/hooks/analytics'

import Achievements from './Achievements'
import CompanyIntroduction from './CompanyIntroduction'
import ImageCardCarousel from './ImageCardCarousel'
import ImagePreviewModal from './ImagePreviewModal'
import TeamMembers from './TeamMembers'

const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect

const VenderAbout = ({ data, venderName, venderId, onContentReady }) => {
  const [previewImage, setPreviewImage] = useState(null)

  useIsomorphicLayoutEffect(() => {
    onContentReady?.()
  }, [onContentReady])

  const handleImageOpen = (image) => {
    GtmAgent.directSendToGTM({
      event: 'living_action',
      living_event_name: 'vender_image_view',
      living_click_name: image?.alt,
      living_click_location: '廠商公司介紹頁',
      living_vender: venderName,
      living_vender_id: venderId,
    })
    setPreviewImage(image)
  }

  return (
    <>
      <CompanyIntroduction introduction={data?.introduction} />
      <Achievements
        achievements={data?.achievements}
        onImageOpen={handleImageOpen}
      />
      <TeamMembers members={data?.teamMembers} />
      <ImageCardCarousel
        title="認證"
        items={data?.certifications}
        onImageOpen={handleImageOpen}
      />
      <ImageCardCarousel
        title="公司執照"
        items={data?.licenses}
        onImageOpen={handleImageOpen}
      />
      <ImagePreviewModal
        open={Boolean(previewImage)}
        image={previewImage}
        onClose={() => setPreviewImage(null)}
      />
    </>
  )
}

export default VenderAbout
